module.exports = __webpack_public_path__ + "img/icon／logo-zh.cdb23ac9.png";